export const UI_TOKENS = {
  text: {
    bodySm: '0.82rem',
    caption: '0.75rem',
    helper: '0.7rem',
    labelXs: '0.68rem',
    buttonSm: '0.78rem',
  },
  menu: {
    itemMinHeight: 32,
    itemPaddingY: 0.5,
  },
} as const;

